import { render, staticRenderFns } from "./WordIcon.vue?vue&type=template&id=66ae9139&scoped=true&"
import script from "./WordIcon.vue?vue&type=script&lang=ts&"
export * from "./WordIcon.vue?vue&type=script&lang=ts&"
import style0 from "./WordIcon.vue?vue&type=style&index=0&id=66ae9139&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ae9139",
  null
  
)

export default component.exports